module.exports = __webpack_public_path__ + "img/becomeMember.de48c340.png";